const mediaItems = [
  {
    title: '虫虫漫话 Vol.1：韩漫为什么这么火',
    desc: '从《她的私密教学》聊到韩国网漫产业，解析韩漫为何能在全球掀起热潮。下拉式阅读格式如何改变了漫画消费方式？',
    duration: '12:30',
    tag: '漫话播客',
    tagColor: 'primary',
    image: 'https://readdy.ai/api/search-image?query=Podcast%20style%20thumbnail%20about%20Korean%20webtoon%20culture%2C%20colorful%20comic%20speech%20bubbles%20and%20microphone%2C%20warm%20coral%20and%20amber%20tones%2C%20modern%20flat%20design%2C%20clean%20cream%20background%2C%20editorial%20layout&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '漫画家专访：对话《剑道独尊》作者',
    desc: '深入了解国漫玄幻巨作《剑道独尊》的创作历程，作者分享角色设计理念与未来剧情走向，虫虫漫画独家呈现。',
    duration: '25:00',
    tag: '作者访谈',
    tagColor: 'accent',
    image: 'https://readdy.ai/api/search-image?query=Interview%20style%20thumbnail%20with%20Chinese%20ink%20brush%20and%20artist%20desk%2C%20traditional%20and%20modern%20art%20tools%20blend%2C%20warm%20sepia%20and%20golden%20accents%2C%20creative%20atmosphere%2C%20clean%20cream%20background&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '漫评精选：本月最值得追的5部新番',
    desc: '虫虫漫画编辑团队每月精选新上线作品深度评测，从画风、剧情到人设全方位分析，帮你快速找到下一部心头好。',
    duration: '08:45',
    tag: '月度漫评',
    tagColor: 'primary',
    image: 'https://readdy.ai/api/search-image?query=Review%20style%20thumbnail%20with%20star%20ratings%20and%20comic%20panels%2C%20colorful%20and%20vibrant%20layout%2C%20warm%20peach%20and%20coral%20tones%2C%20modern%20editorial%20design%2C%20clean%20cream%20background&width=800&height=500&seq=media-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
            精彩集锦
          </h2>
          <p className="text-sm text-foreground-500">虫虫漫画漫话节目、作者访谈与月度漫评精选</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer group"
            >
              <div className="aspect-[16/10] overflow-hidden relative">
                <img
                  src={item.image}
                  alt={`虫虫漫画 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={`虫虫漫画：${item.title}`}
                />
                <div className="absolute bottom-3 left-3 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-foreground-950/70 text-background-50 text-xs">
                  <i className="ri-play-circle-line"></i>
                  <span>{item.duration}</span>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span
                    className={`text-[10px] px-1.5 py-0.5 rounded font-medium whitespace-nowrap ${
                      item.tagColor === 'primary'
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-accent-100 text-accent-700'
                    }`}
                  >
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}